export default "/delivered_icon.d4fcf3e5-046f1c.svg?svgr";